<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="装箱明细"
      width="1200px"
      top="10px"
      class="packMarkDetailRecord"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="packMarkDetail"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="装箱单条码" prop="packBarcode">
            <el-input v-model="packMarkDetail.packBarcode" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分箱号" prop="subCaseNo">
            <el-input v-model="packMarkDetail.subCaseNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="内装数量" prop="actualQty">
            <el-input v-model="packMarkDetail.actualQty" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">装箱明细</div>
      <el-table
          class="tableBox"
          :data="packMarkDetail.recordVOS"
          border
          stripe
          height="40vh">
        <el-table-column prop="barcode" align="left" label="追溯码"/>
        <el-table-column prop="operateTime" align="left" label="扫描时间" width="140"/>
        <el-table-column
            align="center"
            fixed="right"
            width="80px">
          <template #header>
            <el-button type="text" @click="$refs.unRecord.open(packMarkDetail.masterId)">+ 添加</el-button>
          </template>
          <template v-slot="scope">
            <el-button type="danger" @click="deleteRecord(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :disabled="packMarkDetail.recordVOS.length===0"
                 :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <pack-mark-detail-un-record ref="unRecord" @select="selectUnRecord"/>
  </el-dialog>
</template>

<script>
import PackMarkDetailUnRecord from "@/views/DeliveryManage/PackMark/PackMarkDetailUnRecord";

export default {
  name: "PackMarkDetailRecord",
  components: {
    PackMarkDetailUnRecord,
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      index: 0,
      packMarkDetail: {
        pkid: 0,
        masterId: 0,
        packNo: "",
        actualQty: "",
        packBarcode: "",
        subCaseNo: "",
        CaseQty: "",
        relBillId: "",
        requireDate: "",
        status: "",
        statusName: "",
        creatorName: "",
        createTime: "",
        note: "",
        detailVOS: [],
        recordVOS: [],
      },
      ruleValidate: {
        quantity: {required: true, trigger: "blur"},
        relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
      },
    };
  },
  methods: {
    open(id) {
      this.dialogVisible = true;
      this.getData(id);
    },

    initData(orderIds, type) {
      this.contentLoading = true;
      this.$http
          .get("basic", `packMarks/initVo/${orderIds}/${type}`)
          .then((resp) => {
            if (resp.success) {
              this.packMarkDetail = Object.assign(this.packMarkDetail, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },

    deleteRecord(index) {
      this.packMarkDetail.recordVOS.splice(index, 1);
    },
    handleRowAdd() {
      this.$refs.unRecord.open(this.packMarkDetail.masterId);
    },

    getData(id) {
      this.contentLoading = true;
      this.$http
          .get("basic", `packMarkDetails/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.packMarkDetail = Object.assign(this.packMarkDetail, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },

    setIndex(index) {
      this.index = index;
    },

    selectUnRecord(selection) {
      selection.forEach(item => {
        let find = 0;
        this.packMarkDetail.recordVOS.forEach(cur => {
          if (cur.barcode == item.barcode) {
            find = 1;
          }
        });
        if (find === 0) {
          let value = {
            barcode: item.barcode,
          };
          this.packMarkDetail.recordVOS.push(value);
        }
      });

    },
    // 编辑、新建
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.packMarkDetail.recordVOS.length) {
            this.$confirm("明细不能为空", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }

          this.submitLoading = true;
          this.$http
              .post("basic", "packMarkDetails/record", this.packMarkDetail)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.packMarkDetailRecord .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.packMarkDetailRecord .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.packMarkDetailRecord .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.packMarkDetailRecord .el-divider--horizontal {
  margin: 10px 0;
}

.packMarkDetailRecord .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
